import { render } from "./ConstanciaPage.vue?vue&type=template&id=4507b470"
import script from "./ConstanciaPage.vue?vue&type=script&lang=js"
export * from "./ConstanciaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__